import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

export default props => {
    useStyles(classes)
    const { orderSummary } = props
    const { display, doublePointsMultiple } = orderSummary
    return <div className={classes.Container}>
        <div className={classes.Lines}>
            {
                display?.map((d, index) => <div key={index} className={classes.Line}>
                    <div className={classes.LineCon}>
                        <span className={classes.Label} dangerouslySetInnerHTML={{__html: d.label}}/>
                        <span className={classes.Value}>
                            <span dangerouslySetInnerHTML={{__html: d.value}}/>
                            {
                                doublePointsMultiple > '1' && (index === display?.length - 1) && <>
                                    <img className={classes.PointIcon} src='https://image.geeko.ltd/2021-11-01-lottery/2021-11-01-lottery-points.png'/>X{doublePointsMultiple}
                                </>
                            }
                        </span>
                    </div>
                    
                    {
                        d?.asker?.target && <p className={classes.AskerMsg}><span dangerouslySetInnerHTML={{ __html: d.asker.target }}></span></p>  
                    }
                </div>)
            }
        </div>
    </div>
}